module.exports = __webpack_public_path__ + "img/sb.57461f49.png";